import { render, staticRenderFns } from "./PaymentTermsAndPrivacy.vue?vue&type=template&id=63e380ea&scoped=true"
import script from "./PaymentTermsAndPrivacy.vue?vue&type=script&lang=ts"
export * from "./PaymentTermsAndPrivacy.vue?vue&type=script&lang=ts"
import style0 from "./PaymentTermsAndPrivacy.vue?vue&type=style&index=0&id=63e380ea&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e380ea",
  null
  
)

export default component.exports